'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
require('../data/index.js');
require('../error/index.js');
var graphStudioError_model = require('../error/graph-studio-error.model.js');
var dataType_enum = require('../data/data-type.enum.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);

/**
 * GSQL AttributeType json representation interface following the format:
 *   {
 *     "Name": string,
 *     ["FixedSize": int],
 *     ["TupleName": string],
 *     ["KeyTypeName": string],
 *     ["ValueTypeTupleName": string]
 *   }
 *
 * @export
 * @interface GSQLAttributeTypeJson
 */

var supportedAttributeTypes = ['INT', 'UINT', 'BOOL', 'FLOAT', 'DOUBLE', 'STRING', 'STRING COMPRESS', 'DATETIME', 'LIST', 'SET', 'MAP', 'UDT'];
var supportedDiscriminatorAttributeTypes = ['INT', 'UINT', 'STRING', 'DATETIME'];
var supportedPrimaryIdTypes = ['STRING', 'INT', 'UINT', 'DATETIME', 'FLOAT', 'DOUBLE'];
var deprecatedPrimaryIdTypes = ['FLOAT', 'DOUBLE'];
var supportedMapKeyTypes = ['INT', 'STRING', 'STRING COMPRESS', 'DATETIME'];
var supportedContainerValueTypes = ['INT', 'DOUBLE', 'STRING', 'STRING COMPRESS', 'DATETIME', 'UDT'];
var supportedTypesInExpression = ['INT', 'UINT', 'BOOL', 'FLOAT', 'DOUBLE', 'STRING', 'STRING COMPRESS', 'DATETIME'];
var supportedTypesInSizeConfigExpression = ['INT', 'UINT', 'FLOAT', 'DOUBLE'];
var supportedTypesForAttributeIndex = ['INT', 'UINT', 'STRING', 'STRING COMPRESS', 'DATETIME'];

/**
 * AttributeType describes an attribute type, including type name and other
 * additional properties for non-primitive attribute types. For example,
 * FIXED_BINARY has fixedSize property.
 *
 * @export
 * @class AttributeType
 */
var AttributeType = /*#__PURE__*/function () {
  /**
   * Creates an instance of AttributeType.
   *
   * @memberof AttributeType
   */
  function AttributeType() {
    _classCallCheck__default["default"](this, AttributeType);
    this.name = this.tupleName = this.keyTypeName = this.valueTypeName = this.valueTypeTupleName = '';
    this.fixedSize = -1;
    this.hasFixedSize = this.hasTupleName = this.hasKeyTypeName = this.hasValueTypeName = this.hasValueTypeTupleName = false;
  }

  /**
   * Clone the attribute type.
   *
   * @returns {AttributeType}
   * @memberof AttributeType
   */
  return _createClass__default["default"](AttributeType, [{
    key: "clone",
    value: function clone() {
      var attributeType = new AttributeType();
      attributeType.name = this.name;
      attributeType.hasFixedSize = this.hasFixedSize;
      attributeType.fixedSize = this.fixedSize;
      attributeType.hasTupleName = this.hasTupleName;
      attributeType.tupleName = this.tupleName;
      attributeType.hasKeyTypeName = this.hasKeyTypeName;
      attributeType.keyTypeName = this.keyTypeName;
      attributeType.hasValueTypeName = this.hasValueTypeName;
      attributeType.valueTypeName = this.valueTypeName;
      attributeType.hasValueTypeTupleName = this.hasValueTypeTupleName;
      attributeType.valueTypeTupleName = this.valueTypeTupleName;
      return attributeType;
    }

    /**
     * Load Attribute from GSQL AttributeType json representation.
     *
     * @param {GSQLAttributeTypeJson} attributeTypeJson GSQL AttributeType json representation
     * @returns {AttributeType}
     * @memberof AttributeType
     */
  }, {
    key: "loadFromGSQLJson",
    value: function loadFromGSQLJson(attributeTypeJson) {
      // Name
      this.name = attributeTypeJson.Name;

      // FixedSize
      if ('FixedSize' in attributeTypeJson) {
        this.hasFixedSize = true;
        this.fixedSize = attributeTypeJson.FixedSize;
      } else {
        this.hasFixedSize = false;
        this.fixedSize = -1;
      }
      // TupleName
      if ('TupleName' in attributeTypeJson) {
        this.hasTupleName = true;
        this.tupleName = attributeTypeJson.TupleName;
      } else {
        this.hasTupleName = false;
        this.tupleName = '';
      }
      // KeyTypeName
      if ('KeyTypeName' in attributeTypeJson) {
        this.hasKeyTypeName = true;
        this.keyTypeName = attributeTypeJson.KeyTypeName;
      } else {
        this.hasKeyTypeName = false;
        this.keyTypeName = '';
      }
      // ValueTypeName
      if ('ValueTypeName' in attributeTypeJson) {
        this.hasValueTypeName = true;
        this.valueTypeName = attributeTypeJson.ValueTypeName;
      } else {
        this.hasValueTypeName = false;
        this.valueTypeName = '';
      }
      // ValueTypeTupleName
      if ('ValueTypeTupleName' in attributeTypeJson) {
        this.hasValueTypeTupleName = true;
        this.valueTypeTupleName = attributeTypeJson.ValueTypeTupleName;
      } else {
        this.hasValueTypeTupleName = false;
        this.valueTypeTupleName = '';
      }

      // TODO: Now we don't support fixed binary.
      if (!_includesInstanceProperty__default["default"](supportedAttributeTypes).call(supportedAttributeTypes, this.name)) {
        throw new graphStudioError_model.GraphStudioError("".concat(this.name, " is advanced attribute type not ") + 'supported in Graph Studio. Please directly use DDL in GSQL CLI to ' + 'use this attribute type.');
      }
      if (this.hasValueTypeName && !_includesInstanceProperty__default["default"](supportedContainerValueTypes).call(supportedContainerValueTypes, this.valueTypeName)) {
        throw new graphStudioError_model.GraphStudioError("".concat(this.valueTypeName, " is advanced attribute container value type ") + 'not supported in Graph Studio.');
      }
      if (this.hasKeyTypeName && !_includesInstanceProperty__default["default"](supportedMapKeyTypes).call(supportedMapKeyTypes, this.keyTypeName)) {
        throw new graphStudioError_model.GraphStudioError("".concat(this.keyTypeName, " is advanced map attribute key type ") + 'not supported in Graph Studio.');
      }
      return this;
    }

    /**
     * Dump AttributeType into GSQL AttributeType json representation.
     *
     * @returns {GSQLAttributeTypeJson}
     * @memberof AttributeType
     */
  }, {
    key: "dumpToGSQLJson",
    value: function dumpToGSQLJson() {
      var attributeTypeJson = {
        Name: this.name
      };
      if (this.hasFixedSize) {
        attributeTypeJson.FixedSize = this.fixedSize;
      }
      if (this.hasTupleName) {
        attributeTypeJson.TupleName = this.tupleName;
      }
      if (this.hasKeyTypeName) {
        attributeTypeJson.KeyTypeName = this.keyTypeName;
      }
      if (this.hasValueTypeName) {
        attributeTypeJson.ValueTypeName = this.valueTypeName;
      }
      if (this.hasValueTypeTupleName) {
        attributeTypeJson.ValueTypeTupleName = this.valueTypeTupleName;
      }
      return attributeTypeJson;
    }

    /**
     * Get attribute type text.
     * e.g., STRING, SET<DOUBLE>, MAP<INT, STRING>
     *
     * @returns {string}
     * @memberof AttributeType
     */
  }, {
    key: "toString",
    value: function toString() {
      var _context2;
      var result = this.hasTupleName ? this.tupleName : this.name;
      if (this.name === 'MAP') {
        var _context;
        result += _concatInstanceProperty__default["default"](_context = "<".concat(this.keyTypeName, ", ")).call(_context, this.hasValueTypeTupleName ? this.valueTypeTupleName : this.valueTypeName, ">");
      }
      if (_includesInstanceProperty__default["default"](_context2 = ['LIST', 'SET']).call(_context2, this.name)) {
        result += "<".concat(this.hasValueTypeTupleName ? this.valueTypeTupleName : this.valueTypeName, ">");
      }
      return result;
    }

    /**
     * Get the element value type.
     * For primitive types, return the name.
     * For SET and LIST, return the valueTypeName.
     * For MAP, return MAP<keyTypeName, valueTypeName>.
     *
     * @returns {string}
     * @memberof AttributeType
     */
  }, {
    key: "getValueType",
    value: function getValueType() {
      var _context3;
      if (this.name === 'MAP') {
        return this.toString();
      }
      if (_includesInstanceProperty__default["default"](_context3 = ['LIST', 'SET']).call(_context3, this.name)) {
        return this.hasValueTypeTupleName ? this.valueTypeTupleName : this.valueTypeName;
      }
      return this.hasTupleName ? this.tupleName : this.name;
    }

    /**
     * Get the data type of this attibute.
     *
     * @returns {DataType}
     * @memberof AttributeType
     */
  }, {
    key: "getDataType",
    value: function getDataType() {
      switch (this.name) {
        case 'INT':
        case 'UINT':
          return dataType_enum.DataType.Int;
        case 'STRING':
        case 'STRING COMPRESS':
          return dataType_enum.DataType.String;
        case 'FLOAT':
        case 'DOUBLE':
          return dataType_enum.DataType.Real;
        case 'BOOL':
          return dataType_enum.DataType.Bool;
        case 'DATETIME':
          return dataType_enum.DataType.Datetime;
      }
    }
  }]);
}();

exports.AttributeType = AttributeType;
exports.deprecatedPrimaryIdTypes = deprecatedPrimaryIdTypes;
exports.supportedAttributeTypes = supportedAttributeTypes;
exports.supportedContainerValueTypes = supportedContainerValueTypes;
exports.supportedDiscriminatorAttributeTypes = supportedDiscriminatorAttributeTypes;
exports.supportedMapKeyTypes = supportedMapKeyTypes;
exports.supportedPrimaryIdTypes = supportedPrimaryIdTypes;
exports.supportedTypesForAttributeIndex = supportedTypesForAttributeIndex;
exports.supportedTypesInExpression = supportedTypesInExpression;
exports.supportedTypesInSizeConfigExpression = supportedTypesInSizeConfigExpression;
